import {createRouter, createWebHashHistory} from "vue-router/dist/vue-router";
import {getAdyenOnboardingStatus} from "@/api/adyenNotification";

/* lazy load */
const TransactionsView = () => import("@/views/TransactionsView.vue");
const InvoicesView = () => import("@/views/InvoicesView.vue");
const VgasView = () => import("@/views/VgasView.vue");
const OrganizationView = () => import("@/views/OrganizationView.vue");
const RegisterView = () => import("@/views/RegisterView.vue");
const PasswordForgotView = () => import("@/views/PasswordForgotView.vue");
const CashregistersView = () => import("@/views/CashregistersView.vue");
const PartnerView = () => import("@/views/PartnerView.vue");
const LiberisView = () => import("@/views/LiberisView.vue");
const AdyenTransactionsView = () => import("@/views/AdyenTransactionsView.vue");

const routes = [
	{
		path: "/",
		name: "Home",
		meta: {title: "Willkommen"},
		component: TransactionsView,
	},
	{
		path: "/partner",
		name: "Partner",
		meta: {title: "Partner"},
		component: PartnerView,
	},
	{
		path: "/liberis",
		name: "Liberis",
		meta: {title: "Liberis"},
		component: LiberisView,
	},
	{
		path: "/transactions",
		name: "Transactions",
		meta: {title: "Transaktionen"},
		component: TransactionsView,
	},
	{
		path: "/organization",
		name: "Organization",
		meta: {title: "Organisation"},
		component: OrganizationView,
	},
	{
		path: "/statements",
		name: "Statements",
		meta: {title: "VGAs"},
		component: VgasView,
	},
	{
		path: "/invoices",
		name: "Invoices",
		meta: {title: "Rechnungen"},
		component: InvoicesView,
	},
	{
		path: "/cashregisters",
		name: "Cashregisters",
		meta: {title: "Kassenschnitte"},
		component: CashregistersView,
	},
	{
		path: "/payjet-pro-transactions",
		name: "AdyenTransactions",
		meta: {title: "PayJet Pro Transaktionen", requiresAdyenVerified: true},
		component: AdyenTransactionsView,
	},
	{
		path: "/register/:token",
		name: "Register",
		meta: {title: "Registrierung"},
		component: RegisterView,
	},
	{
		path: "/passwordreset",
		name: "PasswordReset",
		meta: {title: "Passwort zurücksetzen"},
		component: PasswordForgotView,
	}
];

const router = createRouter({
	history: createWebHashHistory(),
	routes: routes,
	linkExactActiveClass: 'is-active',
	scrollBehavior() {
		return {
			top: 0,
			left: 0,
			behavior: "smooth",
		};
	},
});

// Block direct navigation to routes that require a verified Adyen customer
router.beforeEach(async (to) => {
	if (!to.meta?.requiresAdyenVerified) return true;
	if (!window.localStorage.getItem("auth_token")) return "/";
	const status = await getAdyenOnboardingStatus();
	return status?.status === "verified" ? true : "/";
});

// Handle chunk load errors (e.g., when app is updated while user has old version loaded)
router.onError((error) => {
	const pattern = /Loading chunk (\d)+ failed/g;
	const isChunkLoadFailed = error.message.match(pattern);
	const targetPath = router.currentRoute.value.fullPath;

	if (isChunkLoadFailed) {
		// Check if we already tried to reload to avoid infinite loops
		const hasReloaded = sessionStorage.getItem('chunk-load-failed');

		if (!hasReloaded) {
			sessionStorage.setItem('chunk-load-failed', 'true');
			window.location.href = targetPath;
		} else {
			// If reload didn't help, clear the flag and show error to user
			sessionStorage.removeItem('chunk-load-failed');
			console.error('Chunk loading failed even after reload:', error);
		}
	}
});

export default router;
